import React, { useState, useEffect, useContext } from "react";
import Input from "../../atoms/input/input";
import InputFiles from "../../atoms/input-files/inputFiles";
import Button from "../../../components/atoms/button/button";
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { INLINES } from '@contentful/rich-text-types';
import useLoginGigya from '../../../shared/hooks/useLoginGigya'
import Loading from "../../atoms/loading/loading";
import useBrowserMode from '../../../shared/hooks/useBrowserMode'
import { towns } from '../../../services/townsCreo.js'
import "./formPreinscription.scss";
import Modal from "../../atoms/modal/modal";
import { postUser, getValidateAccess } from '../../../services/form-intermediacion'
import GlobalContext from '../../../contexts/globalContext';
import { Page, Text, Document, pdf, StyleSheet } from '@react-pdf/renderer';
import { getLegalAspectsByVerticalId, postLegalAspects } from '../../../services/legalAspects.js'
import iconoAlerta from "../../../assets/icons/modal_alerta.svg";
import moment from 'moment';

interface LegalAspectsInterface {
   id?: number;
   name?: string;
   description?: string;
}

const FormPreinscription = (props: any) => {
   const { gigyaAccount } = useLoginGigya();
   const arrForm = props;
   const today = moment(Date.now()).format('YYYY-MM-DD');
   const todayFull = moment(Date.now()).format('YYYY-MM-DD HH:mm:ss');

   const defaultFormValues = {
      firstName: "",
      secondName: "",
      lastName: "",
      secondSurname: "",
      birthDate: "",
      gender: "",
      identityDocument: "",
      idNumType:"",
      expeditionPlace: "",
      ethnicity: "",
      municipality: "",
      neighborhood: "",
      address: "",
      email: "",
      phone: "",
      cellPhone: "",
      secondCellPhone: "",
      announcement: "",
      other_announcement: "",
      attachments: [],
      attachments_cv: [],
      exp_laboral: "",
      time_exp_laboral: "",
      handicap: "",
      other_handicap: "",
      titulo_academico: "",
      binaries: []
   }

   const titles = {
      birthDate: "",
      gender: "",
      expeditionPlace: "",
      ethnicity: "",
      municipality: "",
      neighborhood: "",
      address: "",
      phone: "",
      cellPhone: "",
      secondCellPhone: "",
      announcement: "",
      handicap: "",
      other_handicap: "",
   }

   const { isBrowser } = useBrowserMode();
   const [legalAspects, setlegalAspects] = useState<LegalAspectsInterface>({})
   const [legal, setlegal] = useState<any>([])
   const [validEmail, setvalidEmail] = useState(false);
   const [formValues, setFormValues] = useState(defaultFormValues);
   const Context = useContext(GlobalContext);
   const [titleValues, setTitleValues] = useState(titles);
   const [checkBox, setCheckBox] = useState(false)
   const [secondCheckBox, setsecondCheckBox] = useState(false)
   const [isService, setisService] = useState(true)
   const [loading, setloading] = useState(false)
   const [errorCatch, seterrorCatch] = useState(false);
   const [CodeTypeGender, setCodeTypeGender] = useState("")
   const [isEnd, setisEnd] = useState(false)
   const [validBirthDate, setValidBirthDate] = useState(true);
   const [verify, setVerify] = useState(false)
   const [firstTime, setfirstTime] = useState(true)
   const fullName = formValues.firstName.toUpperCase() + " "
      + (formValues.secondName ? formValues.secondName.toUpperCase() : "") + " "
      + formValues.lastName.toUpperCase() + " "
      + (formValues.secondSurname ? formValues.secondSurname.toUpperCase() : "")
   const [validateAccess, setValidateAccess] = useState(false);

   const getLegalAspects = async () => {
      try {
         const aspects = await getLegalAspectsByVerticalId(5)
         const found = aspects.data.data.find(el => el.name === "PREINSCRIPTION")
         const replaceValues = found.description.replaceAll('%%%%', '__________')
         const desc = replaceValues.split('$$')
         setlegal(desc)
         setlegalAspects(found)
      } catch (error) {
         console.log(error)
      }
   }

   const postLegalAspectsInfo = async () => {
      const body = {
         id: legalAspects.id,
         documentType: '02',
         document: formValues.identityDocument,
         email: null
      }
      try {
         await postLegalAspects(body)
      } catch (error) {
         console.log(error)
      }
   }

   // Actualiza el estado formValues con los inputs.
   const updateFormValues = (value: any, name?: any) => {
    // Covierte los strings del formulario a mayuscula.
    if (name === "municipality" || name === "neighborhood" || name === "firstName" ||
        name === "secondName" || name === "lastName" || name === "secondSurname") {
        name && setFormValues({ ...formValues, [name]: value.toUpperCase() })
    } else {
        name && setFormValues({ ...formValues, [name]: value })
        }
   }

   const updateTitleValues = () => {
      for (let i = 0; i < 1; i++) {
         arrForm[i].referenciaFormulario.map((inp) => {
            let name = inp.nombreId
            if (!["attachments", "personName", "idNum", "idNumType", "email", "identityDocument"].includes(name)) {
               setTitleValues(state => {
                  let newState = state
                  newState[name] = inp.inputPrincipal
                  return newState
               })
            }
         })
      }
   }

   // Validaciones que se disparan al dar click en el boton CONTINUAR
   const checkValidate = async () => {
      if (await getValidateAccess(formValues.identityDocument)) {
         setisService(!isService);
      } else {
         setValidateAccess(true);
         setisService(true);
         setloading(false);
      }
   };

   const handleSendMessage = async () => {
      try {
         setloading(true);

            let payloadResponses: any[] = []
            for (let key in titleValues) {
               let response = {
                  contentfulId: key,
                  questionDescription: titleValues[key],
                  answer: formValues[key] || null,
                  type: requestType(key)
               }
               payloadResponses.push(response)
            }

         let date = {
            contentfulId: 'creationDate',
            questionDescription: 'Fecha de preinscripción',
            answer: todayFull,
            type: 'DATETIME'
         }

            payloadResponses.push(date);

            let payload = {
               formId: 2,
               user: {
                  document: formValues.identityDocument,
                  documentType: '02',
                  fullname: fullName,
                  email: formValues.email.toLowerCase() || null
               },
               responseList: payloadResponses,
               attachmentList: formValues.binaries
            }
            window.sessionStorage.setItem("fullname", fullName);

            const req = await postUser(payload);

            postLegalAspectsInfo()
            if (req.status === 200 && req.data.status === 200) {
               setFormValues(defaultFormValues)
               setisService(false)
               setloading(false)
            } else {
               setisService(false)
               seterrorCatch(true)
            }

            setisEnd(true)

      } catch (error) {
         setloading(false)
         seterrorCatch(true)
         setisService(false)
         console.log(error)
      }
   }

   const requestType = (key: string): string => {
      if (key === "email") return "EMAIL"
      if (key === "birthDate") return "DATE"
      if (key === "cellPhone" || key === "phone" || key === "secondCellPhone") return "NUMBER"
      return "TEXT"
   }

   const readFile = async (file, keyName, count) => {
      return new Promise((resolve) => {
         let reader = new FileReader();
         let suffixFileName = "";
         reader.readAsDataURL(file);
         reader.onload = () => {
            // Cuando un archivo se carga agrega subfijos a los binarios y el back concatena el
            // numero de documento del usuario al nombre del archivo
            if (keyName === "CC") {
               suffixFileName = "_1_" + count;
            } else {
               suffixFileName = "_11";
            }

            let fileType = file.name.match(
               /(\.jpg|\.jpeg|\.png|\.pdf|\.doc|\.docx|\.pdf)$/i
            );
            setFormValues((prev: any) => {
               return {
                  ...prev,
                  binaries: [
                     ...prev.binaries,
                     {
                        fileBase64: reader.result.split(",")[1],
                        key: suffixFileName,
                        type: fileType
                           ? fileType[1].slice(1).toLowerCase()
                           : "otro",
                     },
                  ],
               };
            });
            resolve(true);
         };
      });
   };

   const toBase64 = async (files, keyName) => {
      let count = 1;
      for (let file of files) {
         await readFile(file[0], keyName, count)
         count++;
      }
   };

   // Valida los parametros obligatorios antes de continuar.
   const validateForm = () => {
      return (
         formValues.firstName === "" || formValues.lastName === "" ||
         formValues.birthDate === "" || formValues.gender === "" ||
         formValues.identityDocument === "" || formValues.expeditionPlace === "" ||
         formValues.ethnicity === "" || formValues.municipality === "" ||
         formValues.neighborhood === "" ||formValues.address === "" ||
         formValues.cellPhone === "" || formValues.cellPhone.length < 10 ||
         formValues.secondCellPhone === "" || formValues.secondCellPhone.length < 10 ||
         formValues.email === "" ||  formValues.titulo_academico === "" ||
         formValues.handicap === "" || formValues.exp_laboral === "" ||
         formValues.announcement === "" || formValues.attachments.length == 0 ||
         !validBirthDate || formValues.other_handicap === "" &&  formValues.handicap === "Otra" ||
         formValues.other_announcement === "" && formValues.announcement === "Otro" ||
         formValues.time_exp_laboral === "" && formValues.exp_laboral === "SI"|| !checkBox
      )
   }

   const validateTerms = () => {
      return !secondCheckBox
   }

   // Valida que los campos obligatorios esten diligenciados de lo contrario activa el mensaje de error del campo.
   const errorDetected = (_input): boolean => {

      if (_input.nombreId === "firstName" && formValues.firstName.length === 0 && verify) {
         return true
      }

      if (_input.nombreId === "lastName" && formValues.lastName.length === 0 && verify) {
         return true
      }

      if (_input.nombreId === 'birthDate' && (formValues.birthDate.length === 0 || validBirthDate === false) && verify) return true

      if (_input.nombreId === "gender" && formValues.gender.length === 0 && verify) {
         return true
      }

      if (_input.nombreId === "identityDocument" && formValues.identityDocument.length === 0 && verify) {
         return true
      }

      if (_input.nombreId === "ethnicity" && formValues.ethnicity.length === 0 && verify) {
         return true
      }

      if (_input.nombreId === "expeditionPlace" && formValues.expeditionPlace.length === 0 && verify) {
         return true
      }

      if (_input.nombreId === "municipality" && formValues.municipality.length === 0 && verify) {
         return true
      }

      if (_input.nombreId === "neighborhood" && formValues.neighborhood.length === 0 && verify) {
         return true
      }

      if (_input.nombreId === "address" && formValues.address.length === 0 && verify) {
         return true
      }

      if (_input.nombreId === "announcement" && formValues.announcement.length === 0 && verify) {
         return true
      }

      if (_input.nombreId === "cellPhone" && formValues.cellPhone.length  != 10 && verify) {
           return true
        }

        if (_input.nombreId === "secondCellPhone" && formValues.secondCellPhone.length != 10 && verify) {
            return true
        }

        if (_input.nombreId === "email" && !validEmail && formValues.email.length === 0 && verify) {
            return true
        }

        if (_input.nombreId === "titulo_academico" && formValues.titulo_academico.length === 0 && verify) {
        return true
        }

        if (_input.nombreId === "handicap" && formValues.handicap.length === 0 && verify) {
        return true
        }

        if (_input.nombreId === "exp_laboral" && formValues.exp_laboral.length === 0 && verify) {
        return true
        }

        if (_input.nombreId === "other_handicap" && formValues.other_handicap.length === 0 && verify) {
        return true
        }

        if (_input.nombreId === "other_announcement" && formValues.other_announcement.length === 0 && verify) {
        return true
        }

        if (_input.nombreId === "time_exp_laboral" && formValues.time_exp_laboral.length === 0 && verify) {
        return true
        }

      return false
   }

   const renderHyperlink = (node: any) => {
      return (
         <a href={node.data.uri} target="_blank" rel="noreferrer">
            {node.content[0].value}
         </a>
      );
   };

   const options = {
      renderNode: {
         [INLINES.HYPERLINK]: renderHyperlink,
      },

   };

   const getInput = (_input, _i) => {
      switch (_input.tipoCampo) {
         case "predict":
            return (
               <div className="input__container" key={`input-${_i}`}>
                  <h6 className="input__container__h6">
                     {_input.inputPrincipal}
                  </h6>
                  <Input
                     tabIndex={1 + _i}
                     key={`inp${_i}`}
                     title={_input.inputPrincipal}
                     type={_input.tipoCampo}
                     nameId={_input.nombreId}
                     value={formValues[_input.nombreId]}
                     handleChange={(e) => updateFormValues(e, _input.nombreId)}
                     isError={errorDetected(_input)}
                     errorMessage={_input.mensajeError}
                     options={towns}
                     placeholder={
                        _input.tipoCampo === "select" &&
                        _input.nombreId === "state"
                           ? _input.listaSelect[0]
                           : ""
                     }
                     setCodeTypeGender={CodeTypeGender}
                     gigyaAccount={gigyaAccount}
                  />
               </div>
            );
         case "file":
            return (
               <div className="input__file__container" key={`input-${_i}`}>
                  <h6 className="input__file__container__h6">
                     {_input.inputPrincipal}
                  </h6>
                  <InputFiles
                     key={`inp${_i}`}
                     tabIndex={1 + _i}
                     title={_input.inputPrincipal}
                     nameId={_input.nombreId}
                     value={formValues[_input.nombreId]}
                     handleChange={updateFormValues}
                  />
               </div>
            );

         default:
            return (
               <div className="input__container" key={`input-${_i}`}>
                  <h6 className="input__container__h6">
                     {_input.inputPrincipal}
                  </h6>
                  <Input
                     tabIndex={1 + _i}
                     key={`inp${_i}`}
                     title={_input.inputPrincipal}
                     type={_input.tipoCampo}
                     nameId={_input.nombreId}
                     value={formValues[_input.nombreId]}
                     handleChange={(e) => updateFormValues(e, _input.nombreId)}
                     isError={errorDetected(_input)}
                     errorMessage={_input.mensajeError}
                     options={_input.listaSelect || null}
                     placeholder={
                        _input.tipoCampo === "select" &&
                        _input.nombreId === "state"
                           ? _input.listaSelect[0]
                           : ""
                     }
                     setCodeTypeGender={setCodeTypeGender}
                     gigyaAccount={gigyaAccount}
                  />
               </div>
            );
      }
   };

   const pdfFile = async () => {

      const styles = StyleSheet.create({
         page: {
            marginTop: 40
         },

         title: {
            margin: 0.5,
            fontSize: 10,
            textAlign: 'center',
         },

         subtitle1: {
            marginTop: 20,
            marginRight: 50,
            marginLeft: 50,
            fontSize: 10,
            textAlign: 'justify',
            justifyContent: 'flex-start',
            width: 'auto'
         },

         subtitle2: {
            marginTop: 0.5,
            marginRight: 50,
            marginLeft: 50,
            fontSize: 10,
            textAlign: 'justify',
            justifyContent: 'flex-start',
            width: 'auto'
         },

         main: {
            marginTop: 20,
            fontSize: 10,
            textAlign: 'center',
         },

         content: {
            marginTop: 10,
            marginRight: 50,
            marginLeft: 50,
            fontSize: 10,
            textAlign: 'justify',
            justifyContent: 'center',
            width: 'auto'
         },
      });


      const Doc = (
         <Document>
            <Page style={styles.page}>
               <Text style={styles.title}>
                  PREINSCRIPCIÓN SEGUNDA CONVOCATORIA CREO
               </Text>
               <Text style={styles.title}>
                  Crecemos con Empleo y Oportunidades
               </Text>
               <Text style={styles.title}>
                  Bono de Innovación en Emergencia
               </Text>
               <Text style={styles.subtitle1}>
                  Fecha de preinscripción: {today}
               </Text>
               <Text style={styles.subtitle2}>
                  Ciudad: {formValues.municipality}
               </Text>
               <Text style={styles.main}>
                  AUTORIZACIÓN TRATAMIENTO DE DATOS PERSONALES
               </Text>
               <Text style={styles.content}>
                  Yo {fullName} identificado(a) con la Cédula de Ciudadanía No {formValues.identityDocument} de {formValues.expeditionPlace}, declaró que toda la información suministrada a la Caja de Compensación Familiar de Antioquia - COMFAMA y la Fundación JuanFe, en el marco de la ejecución de la Segunda Convocatoria CREO - Crecemos con Empleo y Oportunidades, así como los documentos que anexo a este formato, es verídica. Igualmente, al firmar este documento, doy mi consentimiento expreso e irrevocable para que tanto la Caja de Compensación Familiar de Antioquia – COMFAMA, como la Fundación JuanFe, recopile y haga uso de mi información personal para, en mi calidad de interesado: a) Socializarme el programa e invitarme a través de diferentes medios de comunicación, llamadas telefónicas, visitas, y demás canales considerados pertinentes, a jornadas informativas y de preinscripción del programa; b) Verificar mi información y criterios de elegibilidad por medio de fuentes públicas y/o privadas; c) Almacenar mi información personal en el sistema de información del programa, propiedad del programa SIBs.CO y en el sistema de información del Departamento para la Prosperidad Social, por un término indeterminado, con el fin de efectuar análisis estadísticos e históricos, realizar reportes de control y compartirla con los demás aliados vinculados al programa; d) Contactarme durante la etapa de socialización del programa, y al finalizar dicha etapa, habiendo sido seleccionado o no como participante del programa, con el fin de entregarme información considerada de mi interés e información sobre nuevos programas, por cualquier medio escrito, digital o telefónico; e) Transferir y/o trasmitir mi información  con terceros dentro y/o fuera de Colombia para el ejercicio y desarrollo de estas mismas finalidades; f) Atender mis trámites, quejas y reclamos; g) Entregarla a autoridades en caso de ser solicitada por ellas. h) Tratar mis datos personales para diseñar y ofrecerme servicios y programas personalizados; i) En caso de conectarme laboralmente autorizo a Comfama y/o la Fundación Juanfe a solicitar información y documentos acerca de mi vinculación laboral.
               </Text>
               <Text style={styles.content}>
                  Así mismo autorizo a que, durante la etapa de socialización y convocatoria, me sean tomadas imágenes fotográficas y de video, por la Caja de Compensación Familiar de Antioquia - COMFAMA, la Fundación JuanFe y/o sus contratistas y aliados, para ser publicadas en desarrollo de campañas promocionales en medios radiales, televisivos o de prensa, así como para incluirlas como material audiovisual en medios impresos, digitales o electrónicos, y en páginas web y/o redes sociales de los diferentes actores vinculados al programa, o en la entrega de informe de resultados del programa, y demás material de apoyo que se considere pertinente para la difusión y promoción del programa. Así mismo declaro conocer que no tengo derecho a recibir compensaciones ni reconocimientos económicos o comerciales por el uso que se le dé a mi imagen para los fines antes señalados. Adicionalmente declaro que:
               </Text>
               <Text style={styles.content}>
                  1. Conozco que mi información personal se mantendrá en el sistema de información del programa durante un periodo de término indeterminado, o hasta que cesen las finalidades ya descritas en este mismo formato.
               </Text>
               <Text style={styles.content}>
                  2. Conozco que el tratamiento de información personal estará sujeta a la protección establecida en la Ley 1581 de 2012, sus decretos reglamentarios, y las normas que lo modifiquen, así como a la política de tratamiento e intercambio de datos personales del programa publicada en www.comfama.com la cual contiene mis derechos, lineamientos, directrices y procedimientos sobre el tratamiento de mi información de acuerdo a lo estipulado en el presente documento, y que por medio del correo electrónico protecciondatospersonales@comfama.com.co podré hacer efectivos mis derechos de conocer, actualizar, rectificar y suprimir mis datos, así como presentar consultas y solicitudes de supresión de datos.
               </Text>
               <Text style={styles.content}>
                  Autorización de firma
               </Text>
               <Text style={styles.content}>
                  ( X ) Leí la totalidad del documento y acepto los términos anteriormente expuestos.
               </Text>
               <Text style={styles.content}>
                  Nombre: {fullName}
                  Cédula: {formValues.identityDocument}
               </Text>
               <Text style={styles.content}>
                  Departamento Administrativo para la Prosperidad Social, en alianza con el Programa de Cooperación Económica Suiza (SECO) y el Banco Interamericano de Desarrollo (BID), en calidad de administrador del Fondo Multilateral de Inversiones.
               </Text>
            </Page>
         </Document>
      )

      const blob = await pdf(Doc).toBlob();
      const reader = new window.FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = function () {
         const base64data = reader.result
         updateFormValues([...formValues.binaries, { fileBase64: base64data.split(",")[1], key: "_2", type: "pdf" }], "binaries")
      };

   }

   const ga_push = () => {
      window.ga_debug = { trace: true };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
         event: "ClicFormulario ",
         category: "FormularioPreinscripcion ",
         action: "Enviarexitoso ",
      });
   }

   useEffect(() => {
      if (isBrowser && Context.gigyaContext.gigyaAccount) {
         props.setIsUser(true)
         var gender: string = ""
         var birth: string = ""
         var typeId: string = ""
         if (Context.gigyaContext.gigyaAccount.profile.birthDay && Context.gigyaContext.gigyaAccount.profile.birthMonth && Context.gigyaContext.gigyaAccount.profile.birthYear) {
            birth = Context.gigyaContext.gigyaAccount.profile.birthYear + "-" +
               (+Context.gigyaContext.gigyaAccount.profile.birthMonth < 10 ? "0" + Context.gigyaContext.gigyaAccount.profile.birthMonth : Context.gigyaContext.gigyaAccount.profile.birthMonth) + "-" +
               (+Context.gigyaContext.gigyaAccount.profile.birthDay < 10 ? "0" + Context.gigyaContext.gigyaAccount.profile.birthDay : Context.gigyaContext.gigyaAccount.profile.birthDay)
         }
         if (Context.gigyaContext.gigyaAccount.profile.gender === "f") { gender = "MUJER"; setCodeTypeGender("MUJER") }
         if (Context.gigyaContext.gigyaAccount.profile.gender === "m") { gender = "HOMBRE"; setCodeTypeGender("HOMBRE") }

         document.getElementById("gender").innerHTML = gender
         document.getElementById("birthDate").innerHTML = birth

         setFormValues({
            ...formValues,
            firstName: Context.gigyaContext.gigyaAccount.profile.firstName,
            secondName: Context.gigyaContext.gigyaAccount.data.secondName,
            lastName: Context.gigyaContext.gigyaAccount.profile.lastName,
            secondSurname: Context.gigyaContext.gigyaAccount.data.secondLastName,
            identityDocument: Context.gigyaContext.gigyaAccount.data.docNumber,
            phone: Context.gigyaContext.gigyaAccount.data.phone,
            cellPhone: Context.gigyaContext.gigyaAccount.data.mobile,
            gender: gender,
            birthDate: birth,
            idNumType: typeId,
            email: Context.gigyaContext.gigyaAccount.profile.email
         })

      } else if (formValues.identityDocument) {
         window.location.href = "/programa-creo"
      }

   }, [Context.gigyaContext.gigyaAccount])

   // Convierte los archivos de tipo CC a base64
   useEffect(() => {
      setFormValues({ ...formValues, binaries: [] });
      if (formValues.attachments) {
         toBase64(formValues.attachments, "CC");
      }
      if (formValues.attachments_cv) {
         toBase64(formValues.attachments_cv, "CV");
      }
   }, [formValues.attachments]);

   // Convierte los archivos de tipo CV a base64
   useEffect(() => {
      setFormValues({ ...formValues, binaries: [] });
      if (formValues.attachments_cv) {
         toBase64(formValues.attachments_cv, "CV");
      }
      if (formValues.attachments) {
         toBase64(formValues.attachments, "CC");
      }
   }, [formValues.attachments_cv]);

   useEffect(() => {
      getLegalAspects()
   }, [])

   useEffect(() => {
      updateTitleValues()
   }, [formValues.identityDocument])

   useEffect(() => {

      let idNumber = document.getElementById('identityDocument');

      idNumber?.addEventListener('change', function (e) {
         let value = e.target.value;
         let initialValue;

         if (value[0] == 0) {
            e.target.value = initialValue;
         }
      })

   }, [formValues.identityDocument])

   useEffect(() => {
      let idNumber = document.getElementById('phone');
      idNumber?.addEventListener('change', function (e) {
         let value = e.target.value;
         let initialValue;
         if (value[0] == 0) {
            e.target.value = initialValue;
         }
      })

   }, [formValues.phone])

   useEffect(() => {
      let idNumber = document.getElementById('cellPhone');
      idNumber?.addEventListener('change', function (e) {
         let value = e.target.value;
         let initialValue;
         if (value[0] == 0) {
            e.target.value = initialValue;
         }
      })

   }, [formValues.cellPhone])

   useEffect(() => {
      let idNumber = document.getElementById('secondCellPhone');
      idNumber?.addEventListener('change', function (e) {
         let value = e.target.value;
         let initialValue;
         if (value[0] == 0) {
            e.target.value = initialValue;
         }
      })

   }, [formValues.secondCellPhone])

   useEffect(() => {
      if (formValues.email) {
         setvalidEmail(!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(formValues.email))
      }
   }, [formValues.email])


   useEffect(() => {
      if (Context.gigyaContext.gigyaAccount?.UID && !localStorage.getItem('uid-pre')) {
         localStorage.setItem('uid-pre', Context.gigyaContext.gigyaAccount?.UID);
         window.location.reload()
      }

   }, [Context.gigyaContext.gigyaAccount])

   useEffect(() => {
      if (formValues.birthDate) {
         let bd = new Date(formValues.birthDate)
         let nw = new Date()
         let dateDiff = nw.getUTCDate() - bd.getUTCDate()
         let monthDiff = nw.getUTCMonth() - bd.getUTCMonth()
         let yearDiff = nw.getUTCFullYear() - bd.getUTCFullYear()

         if (yearDiff > 18 ||
            (yearDiff == 18 &&
               (monthDiff > 0 || (monthDiff == 0 && dateDiff > 0))
            )) {
            setValidBirthDate(true)
         } else {
            setValidBirthDate(false)
         }
      }
   }, [formValues.birthDate])

   return (
      <>
         <div className="o-form o-preinscripcion">
            <div className="o-preinscripcion__container">
               <div className="o-preinscripcion__left">
                  <div id="group0" className="o-form__group--open">
                     <div className="o-form__group-cont">
                        {arrForm && arrForm[0].referenciaFormulario.map((inp, i) => {
                           // Renderiza los campos que dependen de las opciones marcadas en otros campos
                           if (inp.nombreId === 'other_announcement' && formValues?.announcement.trim() !== 'Otro') return
                           if (inp.nombreId === 'time_exp_laboral' && formValues?.exp_laboral.trim() !== 'SI') return
                           if (inp.nombreId === 'other_handicap' && formValues?.handicap.trim() !== 'Otra') return
                           return getInput(inp, i)
                        })}
                     </div>
                  </div>
                  <div id="group3" className="o-form__group--open">
                     <span className="o-form__person-title"> {arrForm[1].tituloGeneral || ""} </span>
                     <div className="o-form__group-cont">
                        {arrForm && arrForm[1].referenciaFormulario.map((inp, i) => (
                           inp.tipoCampo.includes("file") ? (
                              <InputFiles
                                 key={i}
                                 title={inp.inputPrincipal}
                                 nameId={inp.nombreId}
                                 value={formValues[inp.nombreId]}
                                 handleChange={updateFormValues}
                                 maxFiles={2}
                              />
                           ) : (
                              getInput(inp, i)
                           )
                        ))}
                     </div>
                  </div>
               </div>
               <div className="o-preinscripcion__right">
                  <img src={props.image} alt="Imagen contacto" />
               </div>
            </div>
            <div className="o-preinscripcion__bottom">
               <div className="o-form__bottom">
                  <div className="o-form__bottom-txt">
                     {(arrForm && arrForm[2].referenciaFormulario[0].textoTerminos.json.content) && documentToReactComponents(arrForm[2].referenciaFormulario[0].textoTerminos.json, options)}
                  </div>
                  <div className="o-form__bottom-btns">
                     <div className="o-form__bottom-check">
                        <input type="checkbox" id="cbox1" value="first_checkbox" onChange={(e) => { setCheckBox(e.target.checked); setVerify(true) }} />
                        <label htmlFor="cbox1" onClick={() => setVerify(true)}>{arrForm[2].referenciaFormulario[0].tituloBotonTerminos}</label>
                     </div>
                     <div className="o-form__bottom-btn">
                        {loading ? <Loading /> :
                           <Button
                              id={"btn-enviar"}
                              type={"button"}
                              classname={`secondary `}
                              text="Continuar"
                              isDisabled={validateForm()}
                              gtmMark={"gtmFormularioPreinscripcionContinuar"}
                              onClickAction={() => { checkValidate(); firstTime ? pdfFile() : null; }}
                           />
                        }
                     </div>
                  </div>
               </div>
            </div>
         </div>
         {errorCatch &&
            <Modal open={true}>
               <div className="o-form-success">
                  <div className="o-form-success__content">
                     <i className="icon__check icon-close" />
                     <h3 className="o-form-success__content__message">Error al enviar la preinscripción</h3>
                     <p className="o-form-success__content__info">En este momento no podemos procesar su solicitud, por favor intentelo mas tarde.</p>
                     <a href="" className="o-form-success__content__btn" >ACEPTAR</a>
                  </div>
               </div>
            </Modal>

         }

         {
            <Modal
               open={validateAccess}
               className={"modal-validate-access"}
               onClose={() => { }}
            >
               <div className="modal-validate-access__content">
                  <div className="modal-validate-access__content__header">
                     <i
                        className="modal-validate-access__content__header__icon-close icon-close"
                        onClick={() => setValidateAccess(false)}
                     />
                  </div>
                  <div className="modal-validate-access__content__body">
                     <img src={iconoAlerta} className="modal-validate-access__content__body__image" />
                     <h1 className="modal-validate-access__content__body__title">
                        ¡Hola, {fullName}!
                     </h1>
                     <p>
                        Queremos informarte que si te inscribiste en la primera convocatoria del programa CREO Comfama no será posible que hagas parte de la segunda convocatoria, según los requisitos establecidos en el programa.
                     </p>
                     <p>
                        Conoce las oportunidades que tenemos para ti y tu familia en <a href="https://www.comfama.com" target="_blank">www.comfama.com</a>, también te recomendamos
                        visitar nuestra página web <a href="https://www.comfama.com/trabajo-con-proposito/" target="_blank">www.comfama.com/trabajo-con-proposito/</a> y seguirnos en nuestro Instagram <a href="https://www.instagram.com/comfamaempleoyemprendimiento/" target="_blank">@comfamaempleoyemprendimiento</a>. ¡Feliz día!
                     </p>
                     <br />
                     <Button
                        id={"btn-continuar"}
                        type={"button"}
                        classname={`secondary`}
                        text="Aceptar"
                        isDisabled={false}
                        onClickAction={() => {
                           setValidateAccess(false);
                        }}
                     />
                  </div>
               </div>
            </Modal>
         }

         {!isService &&
            <Modal open={true} onClose={() => false}>
               {isEnd === false ? (
                  <div className="o-form-success-pre">
                     <i className="icon-close icon" onClick={() => { setisService(!isService); setfirstTime(false); document.body.classList.remove("a-modal--open") }} />
                     <div className="o-form-success-pre__title">
                        <h3>Preinscripción Segunda Convocatoria CREO</h3>
                     </div>
                     <div className="o-form-success-pre__content">
                        <p className="o-form-success-pre__content__info">
                           <p>PREINSCRIPCIÓN SEGUNDA CONVOCATORIA CREO</p>
                           <p>Crecemos con Empleo y Oportunidades</p>
                           <p>Bono de Innovación en Emergencia</p>
                           <p>Fecha de preinscripción: {today}</p>
                           <p>Ciudad: {formValues.municipality}</p>
                           <p>AUTORIZACIÓN TRATAMIENTO DE DATOS PERSONALES</p>
                           <p>Yo {fullName} identificado(a) con la Cédula de Ciudadanía No {formValues.identityDocument} de {formValues.expeditionPlace}, declaró que toda la información suministrada a la Caja de Compensación Familiar de Antioquia - COMFAMA y la Fundación JuanFe, en el marco de la ejecución de la <strong>Segunda Convocatoria CREO - Crecemos con Empleo y Oportunidades</strong>, así como los documentos que anexo a este formato, es verídica. Igualmente, al firmar este documento, doy mi consentimiento expreso e irrevocable para que tanto la Caja de Compensación Familiar de Antioquia – COMFAMA, como la Fundación JuanFe, recopile y haga uso de mi información personal para, en mi calidad de interesado: a) Socializarme el programa e invitarme a través de diferentes medios de comunicación, llamadas telefónicas, visitas, y demás canales considerados pertinentes, a jornadas informativas y de preinscripción del programa; b) Verificar mi información y criterios de elegibilidad por medio de fuentes públicas y/o privadas; c) Almacenar mi información personal en el sistema de información del programa, propiedad del programa SIBs.CO y en el sistema de información del Departamento para la Prosperidad Social, por un término indeterminado, con el fin de efectuar análisis estadísticos e históricos, realizar reportes de control y compartirla con los demás aliados vinculados al programa; d) Contactarme durante la etapa de socialización del programa, y al finalizar dicha etapa, habiendo sido seleccionado o no como participante del programa, con el fin de entregarme información considerada de mi interés e información sobre nuevos programas, por cualquier medio escrito, digital o telefónico; e) Transferir y/o trasmitir mi información  con terceros dentro y/o fuera de Colombia para el ejercicio y desarrollo de estas mismas finalidades; f) Atender mis trámites, quejas y reclamos; g) Entregarla a autoridades en caso de ser solicitada por ellas. h) Tratar mis datos personales para diseñar y ofrecerme servicios y programas personalizados; i) En caso de conectarme laboralmente autorizo a Comfama y/o la Fundación Juanfe a solicitar información y documentos acerca de mi vinculación laboral.</p>
                           <p>Así mismo autorizo a que, durante la etapa de socialización y convocatoria, me sean tomadas imágenes fotográficas y de video, por la Caja de Compensación Familiar de Antioquia - COMFAMA, la Fundación JuanFe y/o sus contratistas y aliados, para ser publicadas en desarrollo de campañas promocionales en medios radiales, televisivos o de prensa, así como para incluirlas como material audiovisual en medios impresos, digitales o electrónicos, y en páginas web y/o redes sociales de los diferentes actores vinculados al programa, o en la entrega de informe de resultados del programa, y demás material de apoyo que se considere pertinente para la difusión y promoción del programa. Así mismo declaro conocer que no tengo derecho a recibir compensaciones ni reconocimientos económicos o comerciales por el uso que se le dé a mi imagen para los fines antes señalados. Adicionalmente declaro que:</p>
                           <p>1. Conozco que mi información personal se mantendrá en el sistema de información del programa durante un periodo de término indeterminado, o hasta que cesen las finalidades ya descritas en este mismo formato.</p>
                           <p>2. Conozco que el tratamiento de información personal estará sujeta a la protección establecida en la Ley 1581 de 2012, sus decretos reglamentarios, y las normas que lo modifiquen, así como a la política de tratamiento e intercambio de datos personales del programa publicada en www.comfama.com la cual contiene mis derechos, lineamientos, directrices y procedimientos sobre el tratamiento de mi información de acuerdo a lo estipulado en el presente documento, y que por medio del correo electrónico protecciondatospersonales@comfama.com.co podré hacer efectivos mis derechos de conocer, actualizar, rectificar y suprimir mis datos, así como presentar consultas y solicitudes de supresión de datos.</p>
                           <p>Autorización de firma</p>
                           <p>( X ) Leí la totalidad del documento y acepto los términos anteriormente expuestos.</p>
                           <p>Nombre: {fullName}</p>
                           <p>Cédula: {formValues.identityDocument}</p>
                           <p>Departamento Administrativo para la Prosperidad Social, en alianza con el Programa de Cooperación Económica Suiza (SECO) y el Banco Interamericano de Desarrollo (BID), en calidad de administrador del Fondo Multilateral de Inversiones.</p>
                        </p>
                     </div>
                     <div className="o-form-success-pre__content__footer">
                        <div className="o-form-success-pre__content__footer__bottom--check">
                           <input type="checkbox" id="cbox2" value="second_checkbox" onChange={(e) => setsecondCheckBox(e.target.checked)} />
                           <label htmlFor="cbox2">Leí la totalidad del documento y acepto los términos anteriormente expuestos</label>
                        </div>
                        <div className="o-form-success-pre__content__footer__bottom-btn">
                           {loading ? <Loading /> :
                              <Button
                                 id={"btn-enviar"}
                                 type={"button"}
                                 classname={`modal `}
                                 text="Enviar"
                                 isDisabled={validateTerms()}
                                 gtmMark={"gtmFormularioPreinscripcionEnviar"}
                                 onClickAction={() => handleSendMessage()}
                              />
                           }
                        </div>
                     </div>
                  </div>
               ) : (
                  <div className="o-form-success-step2">
                     <div className="o-form-success-step2__content">
                        <i className="icon__check icon-check-circle1" />
                        <p className="o-form-success-step2__content__info">Hola, {window.sessionStorage.getItem("fullname")} <br /><br />Gracias por postularte al programa CREO Comfama. Ten en cuenta que en esta primera etapa de preinscripción se validará la información que nos compartiste para verificar que cumplas con los requisitos. <br /><br /> Una vez validada la información nos comunicaremos contigo. Te recomendamos estar atento.</p>
                        <a href="" className="o-form-success-step2__content__btn" onClick={() => ga_push()}>ACEPTAR</a>
                     </div>
                  </div>
               )}
            </Modal>
         }
      </>
   );
};

export default FormPreinscription;
